import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
/** Components Import */
import Bm10040View from "../../Views/Bases/BM10040";
import Snackbar from "../../Components/Snackbar";
import BasicModal from "../../Components/Modal_Basic";
import Checking from "../../Components/Checking";
import axios from "axios";

function BM10040(props) {
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [file, setFile] = React.useState();
  const [fileName, setFileName] = React.useState();
  const [inputs, setInputs] = React.useState({
    comboList: [],
    comboPlantList: [],
    custTypeList: [],
    cdGubunList: [],
    comboCurrecyCd: [],
    address1: "",
    address2: "",
    businesCloseDt: "",
    businesCondi: "",
    businesType: "",
    businessLicenNo: "",
    cdGubun: "",
    custFilePath: "",
    custFilePathName: "",
    custType: "",
    ceoNm: "",
    cityNm: "",
    corpLicenNo: "",
    createDate: "",
    createId: "",
    fileSize: 0,
    currencyCd: "",
    custCd: "",
    custType: "",
    custCompCd: "",
    custNm: "",
    custShortName: "",
    eMail: "",
    lClassCd: "",
    itemFilePath: "",
    itemFilename: "",
    custTel: "",
    mClassCd: "",
    nationCd: "",
    personCharg: "",
    plantCd: "",
    updateDate: "",
    updateId: "",
    useYn: "Y",
    faxNo: "",
  });
  const {
    address1,
    address2,
    businesCloseDt,
    businesCondi,
    businesType,
    businessLicenNo,
    cdGubun,
    custType,
    ceoNm,
    cityNm,
    corpLicenNo,
    createDate,
    createId,
    currencyCd,
    custCd,
    custCompCd,
    custNm,
    custShortName,
    eMail,
    lClassCd,
    mClassCd,
    nationCd,
    personCharg,
    plantCd,
    updateDate,
    updateId,
    useYn,
    faxNo,
  } = inputs;
  const [lanData, setLanData] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const [changedRowData, setChangedRowData] = React.useState([]);
  const [selectedRowData, setSelectedRowData] = React.useState([]);
  const [modalToggle, setModalToggle] = React.useState(false);
  const [checkInputs, setCheckInputs] = React.useState({
    value1: "",
  });
  const [checkCustCdToggle, setCheckCustCdToggle] = React.useState(false);

  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    Init();
  }, []);

  const Init = async () => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];
    let getComboData = [];

    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);
      //콤보박스
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Common.GetCode,
        {
          groupCd: "string",
        }
      ).then((result) => {
        let data = result.data;
        for (let i = 0; i < data.length; i++) {
          getComboData.push({
            groupCd: data[i].GroupCd,
            value: data[i].Code,
            name: data[i].Name,
          });
        }
        inputs.comboList = getComboData.filter((e) => e.groupCd == "ITEM_TYPE");
        inputs.comboPlantList = getComboData.filter(
          (e) => e.groupCd == "PLANT_CD"
        );
        inputs.custTypeList = getComboData.filter(
          (e) => e.groupCd === "CUST_TYPE"
        );
        inputs.cdGubunList = getComboData.filter(
          (e) => e.groupCd === "CD_GUBUN"
        );
        inputs.comboCurrecyCd = getComboData.filter(
          (e) => e.groupCd === "CURRENCY_CD"
        );
      });
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10040.GetCustMst
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else if (data.type === "Error") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          console.log(data);
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              address1: data[i].address1,
              address2: data[i].address2,
              businesCloseDt: data[i].businesCloseDt
                ? new Date(data[i].businesCloseDt)
                : null,
              businesCondi: data[i].businesCondi,
              businesType: data[i].businesType,
              businessLicenNo: data[i].businessLicenNo,
              cdGubun: data[i].cdGubun,
              cdGubunNm: data[i].cdGubunNm,
              ceoNm: data[i].ceoNm,
              cityNm: data[i].cityNm,
              corpLicenNo: data[i].corpLicenNo,
              createDate: data[i].createDate
                ? Commons.DateFormating(data[i].createDate.toString(), 2)
                : "",
              createId: data[i].createId,
              currencyCd: data[i].currencyCd,
              currencyNm: data[i].currencyNm,
              custCd: data[i].custCd,
              custType: data[i].custType,
              custTypeNm: data[i].custTypeNm,
              custCompCd: data[i].custCompCd,
              custNm: data[i].custNm,
              custFilePath: data[i].custFilePath,
              custFilename: data[i].custFilename,
              custShortName: data[i].custShortName,
              custTel: data[i].custTel,
              eMail: data[i].eMail,
              lClassCd: data[i].lClassCd,
              mClassCd: data[i].mClassCd,
              nationCd: data[i].nationCd,
              personCharg: data[i].personCharg,
              plantCd: data[i].plantCd,
              plantNm: data[i].plantNm,
              updateDate: data[i].updateDate
                ? Commons.DateFormating(data[i].updateDate.toString(), 2)
                : "",
              updateId: data[i].updateId,
              useYn: data[i].useYn,
              faxNo: data[i].faxNo,
            });
          }
          setRowData(Commons.InsertNumber(getRowData));
        }
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const CheckCusCd = async () => {
    Dialog.ProgressBar(true);
    try {
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10040.CheckCustCd,
        { CustCd: checkInputs.value1 }
      ).then((result) => {
        let data = result.data;
        if (data === true) {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_UseokCustCd" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setCheckCustCdToggle(true);
        } else {
          setSnackbars({
            toggle: true,
            type: "error",
            message: lanData.filter(
              (f) => f.lanId === "Snack_UsenoCustCd" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const SaveConfirm = () => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        SaveLogic();
      }
    );
  };
  //파일업로드
  const FileConfirm = () => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        FileLogic();
      }
    );
  };
  //파일업로드
  const FileLogic = async () => {
    const formData = new FormData();
    formData.append("formFile", file);
    formData.append("fileName", fileName);
    formData.append("custCd", inputs.custCd);
    formData.append("filePath", inputs.itemFilePath);
    try {
      await axios
        .post(
          Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10040.FileSave,
          formData
        )
        // .post("https://dongsungprintingmes.com:8080/BM10040/FileSave", formData) //운영
        //.post("http://114.206.84.134:5540/BM10040/FileSave", formData); //테스트

        .then((result) => {
          if (result.data == "success") {
            //파일업로드 성공
            setSnackbars({
              toggle: true,
              type: "info",
              message: "파일업로드 성공",
            });
            Init();
          } else {
            //파일업로드 실패
            setSnackbars({
              toggle: true,
              type: "error",
              message: "파일업로드 실패",
            });
          }
        });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  //다운로드
  const FileDownConfirm = () => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        FileDownLogic();
      }
    );
  };
  //다운로드
  const FileDownLogic = async () => {
    try {
      // await axios
      //   .post("https://localhost:7117/BM10040/FileDownload", {
      //     fileName: fileNmae,
      //   }) //로컬
      // .post("https://dongsungprintingmes.com:8080/BM10040/FileSave", formData) //운영
      //.post("http://114.206.84.134:5540/BM10040/FileSave", formData); //테스트
      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10040.FileDownload,
        {
          fileName: inputs.itemFilename,
        }
      ).then((result) => {
        if (result.data.message == "success") {
          //파일다운로드 성공
          saveAs(result.data.data, inputs.itemFilename);
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_FileDownload" && f.lanType === "SNACK"
            )[0].lanName,
          });
          Init();
        } else {
          //파일다운로드 실패
          setSnackbars({
            toggle: true,
            type: "error",
            message: lanData.filter(
              (f) =>
                f.lanId === "Snack_FileDownloadFail" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  //파일삭제
  const FileDeleteConfirm = () => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        FileDeleteLogic();
      }
    );
  };
  //파일삭제
  const FileDeleteLogic = async () => {
    if (inputs.itemFilename == "" || inputs.itemFilename == undefined) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: "등록된 파일이 없습니다.",
      });
      return false;
    }
    try {
      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10040.FileDelete,
        {
          value: inputs.itemCd,
          chkIndex: "1",
          fileName: inputs.itemFilename,
        }
      ).then((result) => {
        if (result.data == "success") {
          //파일삭제 성공
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_FileUpload" && f.lanType === "SNACK"
            )[0].lanName,
          });
          Init();
        } else {
          //파일삭제 실패
          setSnackbars({
            toggle: true,
            type: "error",
            message: lanData.filter(
              (f) => f.lanId === "Snack_FileUploadFail" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  const SaveLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = null;
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      // if (inputs.custFilePath != null && inputs.custFilename != null) {
      //   FileLogic();
      // }
      await Commons.Axios(
        "post1",
        Global.serverUrls.useUrl +
          Global.urls.logic.Bases.BM10040.CreateCustMst,
        {
          plantCd: inputs.plantCd,
          custCd: inputs.custCd,
          custNm: inputs.custNm,
          lClassCd: inputs.lClassCd,
          mClassCd: inputs.mClassCd,
          custShortName: inputs.custShortName,
          businessLicenNo: inputs.businessLicenNo,
          custCompCd: inputs.custCompCd,
          custType: inputs.custType,
          custTel: inputs.custTel,
          cdGubun: inputs.cdGubun,
          corpLicenNo: inputs.corpLicenNo,
          ceoNm: inputs.ceoNm,
          businesType: inputs.businesType,
          businesCondi: inputs.businesCondi,
          personCharg: inputs.personCharg,
          eMail: inputs.eMail,
          custFilePath: inputs.custFilePath,
          custFilename: inputs.custFilePathName,

          faxNo: inputs.faxNo,
          address1: inputs.address1,
          address2: inputs.address2,
          cityNm: inputs.cityNm,
          nationCd: inputs.nationCd,
          businesCloseDt: !inputs.businesCloseDt
            ? null
            : Commons.DateStrChange(inputs.businesCloseDt),
          currencyCd: inputs.currencyCd,
          useYn: inputs.useYn,
          createId: userInfo.userId,
          // createDate: inputs.createDate,
          updateId: userInfo.userId,
          // updateDate: inputs.updateDate,
        }
      ).then((result) => {
        let data = result.data;

        if (data !== "Ok") {
          setSnackbars({
            toggle: true,
            type: "error",
            message: data,
          });
        } else {
          Init();
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_AddCust" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const DeleteConfirm = () => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        DeleteLogic();
      }
    );
  };

  const DeleteLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = {};
    let deleteData = [];
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      for (let i = 0; i < selectedRowData.length; i++) {
        deleteData.push({
          plantCd: selectedRowData[i].plantCd,
          custCd: selectedRowData[i].custCd,
        });
      }

      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl +
          Global.urls.logic.Bases.BM10040.DeleteCustMst,
        deleteData
      ).then((result) => {
        let data = result.data;

        if (data !== "Ok") {
          setSnackbars({
            toggle: true,
            type: "error",
            message: data,
          });
        } else {
          Init();
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Delete" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  const saveAs = async (blob, fileName) => {
    //base to blod
    const byteCharacters = atob(blob);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob2 = new Blob([byteArray]);
    var link = document.createElement("a");
    link.href = URL.createObjectURL(blob2);
    link.download = fileName;
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const ResetCustCd = () => {
    setInputs({
      ...inputs,
      custNm: "",
      lClassCd: "",
      mClassCd: "",
      custShortName: "",
      businessLicenNo: "",
      custCompCd: "",
      cdGubun: "",
      corpLicenNo: "",
      ceoNm: "",
      businesType: "",
      businesCondi: "",
      personCharg: "",
      eMail: "",
      faxNo: "",
      address1: "",
      address2: "",
      cityNm: "",
      nationCd: "",
      businesCloseDt: "",
      currencyCd: "",
      saleVatCd: "",
      purchVatCd: "",
      coa: "",
      mmPayterm: "",
      paymentCondiCd: "",
      accApproveYn: "",
      useYn: "",
    });
  };

  return (
    <>
      <Bm10040View
        lanData={lanData}
        rowData={rowData}
        setRowData={setRowData}
        changedRowData={changedRowData}
        setChangedRowData={setChangedRowData}
        selectedRowData={selectedRowData}
        setSelectedRowData={setSelectedRowData}
        setSnackbars={setSnackbars}
        snackbars={snackbars}
        inputs={inputs}
        setInputs={setInputs}
        file={file}
        setFile={setFile}
        fileName={fileName}
        setFileName={setFileName}
        SaveConfirm={SaveConfirm}
        FileConfirm={FileConfirm}
        DeleteConfirm={DeleteConfirm}
        setModalToggle={setModalToggle}
        modalToggle={modalToggle}
        FileDownConfirm={FileDownConfirm}
        FileDeleteConfirm={FileDeleteConfirm}
        setCheckCustCdToggle={setCheckCustCdToggle}
        checkCustCdToggle={checkCustCdToggle}
        checkInputs={checkInputs}
        ResetCustCd={ResetCustCd}
        setCheckInputs={setCheckInputs}
      />
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
      {modalToggle && (
        <BasicModal
          name={
            lanData.length > 0
              ? lanData.filter(
                  (f) =>
                    f.lanId === "Dia_CustManagement" && f.lanType === "DIALOG"
                )[0].lanName
              : ""
          }
          onClose={() => setModalToggle(false)}
          buttonName1={
            lanData.length > 0
              ? lanData.filter(
                  (f) => f.lanId === "Btn_Check" && f.lanType === "BTN"
                )[0].lanName
              : ""
          }
          execLogic={() => {
            CheckCusCd();
          }}
        >
          <Checking
            datas={[
              {
                name:
                  lanData.length > 0
                    ? lanData.filter(
                        (f) =>
                          f.lanId === "Dia_CustCd" && f.lanType === "DIALOG"
                      )[0].lanName
                    : "",
                value: checkInputs.value1,
                onChange: (e) => {
                  setCheckInputs({
                    ...checkInputs,
                    value1: e.target.value,
                  });
                },
              },
            ]}
          />
        </BasicModal>
      )}
    </>
  );
}

export default BM10040;
